const mewsReserveLink =
  'https://app.mews.com/distributor/c47752a6-883c-44c6-9b0d-b345008c6065';

export { mewsReserveLink };
